import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HolidayTypeActions } from './holiday-type.actions';
import { catchError, map, mergeMap, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { HolidayTypeService } from '@core/services/holiday-type.service';

@Injectable()
export class HolidayTypeEffects {
  private actions$ = inject(Actions);
  private holidayTypeService = inject(HolidayTypeService);
  private translateService = inject(TranslateService);
  getHolidays$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HolidayTypeActions.loadHolidayType),
      mergeMap((data) =>
        this.holidayTypeService.getHolidayTypes(data).pipe(
          map((holidays) =>
            holidays.success
              ? HolidayTypeActions.loadHolidayTypeSuccess(holidays)
              : HolidayTypeActions.loadHolidayTypeFailure(holidays)
          ),
          catchError((error) =>
            of(
              HolidayTypeActions.loadHolidayTypeFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );

  addHoliday$ = createEffect(() =>
    this.actions$.pipe(
      ofType(HolidayTypeActions.addEditHolidayType),
      mergeMap((data) =>
        this.holidayTypeService.addHolidayType(data).pipe(
          map((holiday) => {
            if (holiday.success) {
              return data.id
                ? HolidayTypeActions.updateHolidayTypeSuccess(holiday)
                : HolidayTypeActions.addHolidayTypeSuccess(holiday);
            } else return HolidayTypeActions.addHolidayTypeFailure(holiday);
          }),
          catchError((error) =>
            of(
              HolidayTypeActions.addHolidayTypeFailure({
                error,
                success: false,
                message: this.translateService.instant('Something went wrong'),
              })
            )
          )
        )
      )
    )
  );
}
